module.exports = __webpack_public_path__ + "img/610d849.webp";